"use strict";

(() => {
  let headerHeight, catalogListRect, catalogListOffset, activeSubcatalog;
  let lastScroll = 0;
  const documentDirection = document.dir === 'rtl' ? 'rtl' : 'ltr';
  const primaryMenuItems = Array.from(document.querySelectorAll(".js-header-primary-item"));
  const secondaryMenuItems = Array.from(document.querySelectorAll(".js-header-secondary-item"));
  const catalogMenuItems = Array.from(document.querySelectorAll(".js-header-catalog-item"));
  const listBackButtons = Array.from(document.querySelectorAll(".js-header-list-back-button"));
  const firstLevelDropdowns = Array.from(document.querySelectorAll(".js-menu-parent .header-catalog__link"));
  const secondLevelDropdowns = Array.from(document.querySelectorAll(".js-menu-level-3"));
  const catalogDropdowns = Array.from(document.querySelectorAll(".js-menu-parent .header-subnav__link--with-next-level"));
  const menuLists = Array.from(document.querySelectorAll(".js-menu-list"));
  const hamburgerButton = document.querySelector(".js-header-hamburger-button");
  const catalogButton = document.querySelector(".js-header-catalog-button");
  const catalogWrapper = document.querySelector(".js-header-catalog-wrapper");
  const cartContent = document.querySelector(".js-header-cart-content");
  const catalogList = document.querySelector(".js-header-catalog-list");
  const cartButton = document.querySelector("#header-cart-btn");
  const header = document.querySelector(".js-header");
  const headerOverlay = document.querySelector(".js-header-overlay");
  const menuItems = [...primaryMenuItems, ...secondaryMenuItems];
  const menuDropdowns = [catalogButton, ...firstLevelDropdowns, ...secondLevelDropdowns, ...catalogDropdowns];
  const scrollUpClass = "gr-scroll-up";
  const scrollDownClass = "gr-scroll-down";
  function updateCartContent() {
    let showLineItemError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let errorId = arguments.length > 1 ? arguments[1] : undefined;
    let errorQuantity = arguments.length > 2 ? arguments[2] : undefined;
    fetch(window.Shopify.routes.root + 'cart?section_id=cart-preview').then(res => res.text()).then(html => {
      const oldJsContent = cartContent.querySelector(".js-contents");
      if (oldJsContent) {
        const parsedContent = new DOMParser().parseFromString(html, "text/html").querySelector(".js-contents");
        if (parsedContent) {
          const clone = oldJsContent.cloneNode(true);
          clone.className = parsedContent.className;
          clone.innerHTML = parsedContent.innerHTML;
          if (showLineItemError) {
            const lineItemError = clone.querySelector(`.js-line-item-error[data-id="${errorId}"]`);
            const lineItemErrorText = lineItemError.querySelector(".js-line-item-error-text");
            if (lineItemError) lineItemError.classList.remove("hidden");
            if (lineItemErrorText) lineItemErrorText.textContent = window.cartStrings.quantityError.replace('[quantity]', errorQuantity);
          }
          oldJsContent.parentNode.replaceChild(clone, oldJsContent);
        }
      }
    }).catch(error => {
      cartContent.innerHTML = "Loading error!";
    });
  }
  function updateCartQuantity(id, quantity, prevQuantity) {
    const url = window.Shopify.routes.root + "cart/change.js";
    const formData = new FormData();
    formData.set("id", id);
    formData.set("quantity", quantity);
    fetch(url, {
      method: "POST",
      body: formData
    }).then(res => res.json()).then(data => {
      if (!data.items) {
        updateCartContent(true, id, prevQuantity);
        return;
      }
      const lineItem = data.items.find(x => x.id == id);
      if (lineItem && typeof prevQuantity !== typeof undefined && lineItem.quantity == prevQuantity) {
        updateCartContent(true, id, lineItem.quantity);
      } else {
        updateCartContent();
      }
      const headerCartQty = document.querySelector("#cart-icon-bubble");
      if (headerCartQty) {
        headerCartQty.textContent = data.item_count;
      }
    });
  }
  function handleBackButton(event) {
    event.preventDefault();
    event.stopPropagation();
    const menuList = event.target.closest(".js-menu-list");
    if (!menuList) return;
    menuList.classList.remove("this-active");
    Array.from(menuList.querySelectorAll(".this-active")).forEach(_activeEl => {
      _activeEl.classList.remove("this-active");
    });
  }
  function handleWindowScroll(event) {
    if (stickyHeader) {
      const currentScroll = window.pageYOffset;
      let thisHeight = calcStickyHeader();
      if (currentScroll <= thisHeight) {
        document.body.classList.remove(scrollUpClass);
        return;
      }
      if (currentScroll > lastScroll && !document.body.classList.contains(scrollDownClass)) {
        // down
        document.body.classList.remove(scrollUpClass);
        document.body.classList.add(scrollDownClass);
      } else if (currentScroll < lastScroll && document.body.classList.contains(scrollDownClass)) {
        // up
        document.body.classList.remove(scrollDownClass);
        document.body.classList.add(scrollUpClass);
      }
      lastScroll = currentScroll;
    }
  }
  function toggleMenuVisibility(event) {
    const parent = event.target.closest(".js-menu-parent");
    const menuList = parent ? parent.querySelector(".js-menu-list") : false;
    if (!parent) return;
    if (!menuList) return;
    if (event.target.classList.contains("js-menu-list")) return;
    if (!containsClasses(menuList, ["js-header-primary-list", "js-header-secondary-list", "js-header-catalog-list", "js-header-catalog-sublist"])) return;
    switch (event.type) {
      case "click":
        if (isTabletOrMobile()) {
          if (!event.target.classList.contains("header-subnav__link")) {
            event.preventDefault();
            event.stopPropagation();
          }
          menuList.classList.add("this-active");
          if (catalogList && catalogList.contains(menuList)) {
            activeSubcatalog = menuList;
            calculateHeaderConstraints();
            recalculateCatalogOverflow();
          }
        }
        break;
      case "mouseenter":
      case "mouseover":
        if (isTabletOrMobile()) return;
        menuList.classList.add("this-active");
        if (menuList.classList.contains("js-header-catalog-sublist") && catalogList) {
          catalogList.classList.add("double-active");
        }
        if (catalogList && catalogList.contains(menuList)) {
          activeSubcatalog = menuList;
          Array.from(document.querySelectorAll(".js-header-catalog-sublist")).forEach(element => {
            element.classList.toggle("this-active", element == menuList);
          });
          calculateHeaderConstraints();
        }
        recalculateCatalogOverflow();
        break;
      case "mouseleave":
        if (isTabletOrMobile()) return;
        menuList.classList.remove("this-active");
        if (catalogList) catalogList.classList.remove("double-active");
        break;
      case "mouseout":
        if (isTabletOrMobile()) return;
        setTimeout(() => {
          if (event.relatedTarget && !event.relatedTarget.closest(".js-header-catalog-sublist") && !event.relatedTarget.classList.contains("js-header-catalog-sublist") && !event.relatedTarget.classList.contains("js-header-catalog-list") && !event.relatedTarget.classList.contains("header-subnav__link--with-next-level")) {
            menuList.classList.remove("this-active");
            if (catalogList && !document.querySelector(".js-header-catalog-sublist.this-active")) {
              catalogList.classList.remove("double-active");
            }
          }
        }, 250);
        break;
    }
  }
  function toggleCatalogMenu(event) {
    if (!catalogList) return;
    switch (event.type) {
      case "click":
        catalogList.classList.toggle("this-active");
        catalogList.classList.remove("double-active");
        toggleHeaderBackdrop();
        break;
      case "mouseenter":
        if (isTabletOrMobile()) return;
        catalogList.classList.add("this-active");
        catalogList.classList.remove("double-active");
        toggleHeaderBackdrop(true);
        Array.from(document.querySelectorAll(".js-header-catalog-sublist")).forEach(element => {
          element.classList.remove("this-active");
        });
        recalculateCatalogOverflow();
        break;
      case "mouseleave":
        if (isTabletOrMobile()) return;
        catalogList.classList.remove("this-active");
        catalogList.classList.remove("double-active");
        toggleHeaderBackdrop(false);
        break;
    }
  }
  function fixHeaderPosition() {
    headerHeight = header.getBoundingClientRect().height;
    let _top = headerHeight;
    if (isTabletOrMobile()) {
      if (catalogList) catalogList.style.top = _top + "px";
      if (catalogWrapper) catalogWrapper.style.top = _top + "px";
      Array.from(document.querySelectorAll(".js-menu-list")).forEach(_menu => {
        _menu.style.top = _top + "px";
      });
    } else {
      if (catalogList) catalogList.style.top = null;
      if (catalogWrapper) catalogWrapper.style.top = null;
      Array.from(document.querySelectorAll(".js-menu-list")).forEach(_menu => {
        _menu.style.top = null;
      });
    }
    if (activeSubcatalog && document.documentElement.clientWidth >= 768) {
      _top = catalogList.getBoundingClientRect().top;
      activeSubcatalog.style.insetInlineStart = -window.scrollX + catalogListOffset + "px";
      activeSubcatalog.style.top = _top + "px";
    } else if (activeSubcatalog) {
      _top = headerHeight;
      activeSubcatalog.style.insetInlineStart = 0;
      activeSubcatalog.style.top = _top + "px";
    }
  }
  function calculateHeaderConstraints() {
    headerHeight = header.getBoundingClientRect().height;
    catalogListRect = catalogList ? catalogList.getBoundingClientRect() : {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    catalogListOffset = documentDirection === "rtl" ? document.documentElement.clientWidth - catalogListRect.left : catalogListRect.left + catalogListRect.width;
    if (activeSubcatalog && document.documentElement.clientWidth > 768) {
      activeSubcatalog.style.height = catalogListRect.height + "px";
    } else if (activeSubcatalog) {
      activeSubcatalog.style.height = null;
    }
    fixMenuClasses();
    fixHeaderPosition();
  }
  function recalculateCatalogOverflow() {
    menuLists.forEach(menu => {
      if (menu.classList.contains("js-header-catalog-sublist")) return;
      const menuRect = menu.getBoundingClientRect();
      if (menuRect.height > 0) {
        menu.style.insetInlineStart = null;
        menu.style.width = null;
        menu.style.height = null;
        const totalWidth = documentDirection === "rtl" ? document.documentElement.clientWidth - menuRect.right + menuRect.width : menuRect.right;
        const totalHeight = header.getBoundingClientRect().height + menuRect.height + (isTabletOrMobile() ? 0 : 10);
        if (totalWidth > window.innerWidth) {
          const overflow = window.innerWidth - totalWidth;
          const newLeft = overflow;
          menu.style.insetInlineStart = newLeft + "px";
        }
        if (totalHeight > window.innerHeight) {
          const overflow = menuRect.bottom - window.innerHeight;
          const newHeight = menu.offsetHeight - overflow - (isTabletOrMobile() ? 0 : 10);
          if (newHeight <= menuRect.height) {
            menu.style.height = newHeight + "px";
          }
        }
      }
    });
  }
  function fixMenuClasses() {
    if (isTabletOrMobile()) {
      menuItems.forEach(_item => {
        const _menuList = _item.querySelector(".js-menu-list");
        if (_menuList) _menuList.classList.remove("header-subcatalog");
      });
    } else {
      menuItems.forEach(_item => {
        const _menuList = _item.querySelector(".js-menu-list");
        if (_menuList) _menuList.classList.add("header-subcatalog");
      });
    }
  }
  function containsClasses(element, classes) {
    if (!element) return false;
    return classes.some(x => element.classList.contains(x));
  }
  function attachEventToElements(elements, eventName, eventHandler) {
    Array.from(elements).forEach(element => {
      element.addEventListener(eventName, eventHandler);
    });
  }
  function isTabletOrMobile() {
    return document.documentElement.clientWidth < 1280;
  }
  function onHeaderCatalogSubnavClick(event) {
    if (isTabletOrMobile()) {
      event.preventDefault();
      event.stopPropagation();
      if (!event.target) return;
      const _menuParent = event.target.closest(".js-menu-parent");
      if (!_menuParent) return;
      const _menuList = _menuParent.querySelector(".js-menu-list");
      if (!_menuList) return;
      activeSubcatalog = _menuList;
      _menuList.classList.add("this-active");
      if (catalogList) catalogList.classList.add("double-active");
      calculateHeaderConstraints();
    }
  }
  function headerOpenCartPopup() {
    let update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const popup = document.getElementById("header-cart-modal");
    popup && popup.classList.add("this-active");
    fixHeaderPosition();
    if (update) updateCartContent();
  }
  function handleMenuDropdownFocus(event) {
    let menuList;
    if (event.target.closest("li")) {
      menuList = event.target.closest("li").querySelector("ul");
    }
    if (event.target == catalogButton) {
      catalogList && catalogList.classList.add("this-active");
      toggleHeaderBackdrop(true);
      activeSubcatalog = false;
      calculateHeaderConstraints();
      recalculateCatalogOverflow();
      return;
    }
    if (menuList && menuList.classList.contains("js-header-catalog-sublist")) {
      menuList.classList.add("this-active");
      catalogList && catalogList.classList.add("double-active");
      activeSubcatalog = menuList;
      calculateHeaderConstraints();
      recalculateCatalogOverflow();
      return;
    }
    if (menuList && menuList.classList.contains("js-menu-list")) {
      menuList.classList.add("this-active");
      recalculateCatalogOverflow();
      return;
    }
    if (menuList && menuList.classList.contains("menu-level-3")) {
      event.target.closest(".header-subnav__link-wrap").classList.add("show-level-3-active");
      return;
    }
  }
  function handleWindowBlur(event) {
    let menuList;
    const originalTarget = event.originalTarget || event.srcElement;
    const originalTargetClosest = originalTarget && originalTarget.closest("li.js-menu-parent");
    if (originalTarget == catalogButton || catalogList && catalogList?.contains(originalTarget)) {
      menuList = catalogList;
    }
    if (originalTargetClosest) {
      menuList = originalTargetClosest.querySelector("ul");
    }
    if (!menuList) {
      return;
    }
    if (menuList && menuList.classList.contains("menu-level-3") || event.relatedTarget && menuList && menuList.contains(event.relatedTarget) || event.relatedTarget && event.relatedTarget.contains(originalTarget)) {
      return;
    }
    activeSubcatalog = false;
    menuList.classList.remove("this-active");
    if (menuList.classList.contains("js-header-catalog-sublist")) {
      catalogList && catalogList.classList.remove("double-active");
    }
    if (menuList.classList.contains("js-header-catalog-list")) {
      toggleHeaderBackdrop(false);
    }
    calculateHeaderConstraints();
  }
  function assignListeners() {
    attachEventToElements(menuItems, "click", toggleMenuVisibility);
    attachEventToElements(menuItems, "mouseenter", toggleMenuVisibility);
    attachEventToElements(catalogMenuItems, "mouseover", toggleMenuVisibility);
    attachEventToElements(menuItems, "mouseleave", toggleMenuVisibility);
    attachEventToElements(catalogMenuItems, "mouseout", toggleMenuVisibility);
    attachEventToElements(listBackButtons, "click", handleBackButton);
    attachEventToElements(menuDropdowns, "focus", handleMenuDropdownFocus);
    catalogButton && catalogButton.addEventListener("click", toggleCatalogMenu);
    catalogButton && catalogButton.addEventListener("mouseenter", toggleCatalogMenu);
    catalogList && catalogList.addEventListener("mouseleave", toggleCatalogMenu);
    document.body.addEventListener('focusout', handleWindowBlur);
    window.addEventListener('scroll', handleWindowScroll, {
      passive: true
    });
    hamburgerButton && hamburgerButton.addEventListener("click", function (event) {
      fixHeaderPosition();
      Array.from(document.querySelectorAll(".js-header-primary-list.this-active," + ".js-header-secondary-list.this-active," + ".js-header-catalog-list.this-active," + ".js-header-catalog-sublist.this-active")).forEach(_el => {
        _el.classList.remove("this-active");
      });
      document.body.classList.toggle("header-menu-active");
      if (catalogList) {
        catalogList.classList.toggle("header-menu-active");
      }
      toggleHeaderBackdrop(document.body.classList.contains("header-menu-active"));
    });
    cartButton && cartButton.addEventListener("click", function (event) {
      document.body.classList.remove("header-menu-active");
      fixHeaderPosition();
      updateCartContent();
    });
    cartContent && cartContent.addEventListener("click", function (event) {
      const target = event.target.closest("[data-js]");
      if (!target || !cartContent.contains(target)) return;
      let newQuantity = 0;
      const variantId = +target.dataset.varId;
      const oldQuantity = +target.dataset.varQty;
      if (target.dataset.js == "minus-btn") {
        newQuantity = Math.max(0, oldQuantity - 1);
      } else if (target.dataset.js == "plus-btn") {
        newQuantity = oldQuantity + 1;
      } else if (target.dataset.js == "remove-btn") {
        event.preventDefault();
        event.stopPropagation();
        newQuantity = 0;
      } else {
        return;
      }
      const cartLineItem = target.closest(".cart-preview-item");
      if (cartLineItem) {
        const spinner = cartLineItem.querySelector(".js-loading-spinner");
        if (spinner) spinner.classList.remove("hidden");
      }
      updateCartQuantity(variantId, newQuantity, +target.dataset.varQty);
    });
    headerOverlay && headerOverlay.addEventListener("click", function (event) {
      document.body.classList.remove("header-menu-active");
      toggleHeaderBackdrop(false);
    });
    cartContent && cartContent.addEventListener("change", function (event) {
      const target = event.target.closest("[data-js]");
      if (!target || !cartContent.contains(target)) return;
      if (target.dataset.js == "qty-input") {
        const cartLineItem = target.closest(".cart-preview-item");
        if (cartLineItem) {
          const spinner = cartLineItem.querySelector(".js-loading-spinner");
          if (spinner) spinner.classList.remove("hidden");
        }
        updateCartQuantity(+target.dataset.varId, +target.value, +target.dataset.varQty);
      }
    });
    catalogButton && catalogButton.addEventListener("mouseleave", function (event) {
      if (isTabletOrMobile()) return;
      if (event.relatedTarget && !containsClasses(event.relatedTarget, ["js-menu-list", "header-subnav__link"])) {
        if (catalogList) {
          catalogList.classList.remove("this-active");
          toggleHeaderBackdrop(false);
        }
      }
    });
    window.addEventListener('resize', event => {
      document.body.classList.remove("header-backdrop-active");
      document.body.classList.remove("header-menu-active");
      recalculateCatalogOverflow();
      calculateHeaderConstraints(event);
      if (document.body.classList.contains('header-backdrop-active')) {
        document.body.classList.remove('header-backdrop-active');
        document.body.style.maxWidth = null;
        const maxWidth = document.body.clientWidth;
        document.body.classList.add('header-backdrop-active');
        document.body.style.maxWidth = maxWidth + "px";
        headerOverlay.style.top = header.getBoundingClientRect().height - 1 + "px";
      } else {
        document.body.style.maxWidth = null;
        document.querySelector('.header-nav').style = null;
      }
    }, true);
  }
  function init() {
    assignListeners();
    headerHeight = header.getBoundingClientRect().height;
    fixMenuClasses();
    if (stickyHeader) {
      header.classList.add("sticky-header");
    }
    toggleMenuThirdLevel();
    window.onHeaderCatalogSubnavClick = onHeaderCatalogSubnavClick;
    window.headerOpenCartPopup = headerOpenCartPopup;
  }
  init();
  function calcStickyHeader() {
    const headerRect = header.getBoundingClientRect();
    const headerTop = headerRect.top;
    const headerHeight = headerRect.height;
    const heightSticky = headerTop + headerHeight;
    return heightSticky;
  }
  function toggleMenuThirdLevel() {
    const elements = document.querySelectorAll('.show-level-3');
    elements.forEach(element => {
      element.addEventListener('click', () => {
        const parentElement = element.parentElement;
        parentElement.classList.toggle('show-level-3-active');
        recalculateCatalogOverflow();
      });
    });
  }
  function toggleHeaderBackdrop() {
    let active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
    let desired;
    if (active === true) {
      desired = true;
    } else if (active === false) {
      desired = false;
    } else if (active === 'auto') {
      if (document.body.classList.contains('header-backdrop-active') || document.body.classList.contains('header-menu-active')) desired = false;else desired = true;
    }
    document.body.classList.remove('header-backdrop-active');
    document.body.style.maxWidth = null;
    document.querySelector('.header-nav').style = null;
    const maxWidth = document.body.clientWidth;
    if (desired) {
      document.body.classList.add('header-backdrop-active');
      document.body.style.maxWidth = maxWidth + "px";
      document.querySelector('.header-nav').setAttribute('style', '--before-max-width: ' + maxWidth + 'px;');
    }
  }
})();